import React, {
  ReactElement,
  ComponentPropsWithoutRef,
  OptionHTMLAttributes,
  DetailedHTMLProps,
} from 'react';
import { FormGroup, FormGroupProps } from '../FormGroup/components/FormGroup';
import { FormGroupText } from '../FormGroup/components/FormGroupText';

type OptionValue = DetailedHTMLProps<
  OptionHTMLAttributes<HTMLOptionElement>,
  HTMLOptionElement
>['value'];

export interface SelectOption<T extends OptionValue> {
  name: string;
  value: T;
}

export type SelectProps<T extends OptionValue> =
  ComponentPropsWithoutRef<'select'> & {
    className?: string;
    errors?: FormGroupProps['errors'];
    inline?: FormGroupProps['inline'];
    label: string;
    options: SelectOption<T>[];
  };

export function Select<T extends OptionValue>({
  className,
  errors = [],
  id,
  inline = false,
  label,
  options,
  ...rest
}: SelectProps<T>): ReactElement {
  return (
    <FormGroup errors={errors} inline={inline} className={className}>
      <FormGroupText className="select">
        <select id={id} {...rest}>
          {options.map((option) => (
            <option value={option.value} key={option.name}>
              {option.name}
            </option>
          ))}
        </select>
        <label htmlFor={id}>{label}</label>
      </FormGroupText>
    </FormGroup>
  );
}
